let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("478av")).then(() => parcelRequire('5jBPz'));